module.exports = __webpack_public_path__ + "static/media/default-image.537e7ea2.jpg";